module.exports = __webpack_public_path__ + "static/media/18ECA2.0fbbe1f2.jpg";